/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 2500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 2500; (i < 5000 && i<maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 5000; (i < 6000 && i<maxDiamondPrice); i = i+15) {
    price.push(i);
  };
  for (var i = 6000; (i < 7000 && i<maxDiamondPrice); i = i+20) {
    price.push(i);
  };
  for (var i = 7000; (i < 8000 && i<maxDiamondPrice); i = i+25) {
    price.push(i);
  };
  for (var i = 8000; (i < 9000 && i<maxDiamondPrice); i = i+30) {
    price.push(i);
  };
  for (var i = 9000; (i < 10000 && i<maxDiamondPrice); i = i+35) {
    price.push(i);
  };
  for (var i = 10000; (i < 15000 && i<maxDiamondPrice); i = i+40) {
    price.push(i);
  };
  for (var i = 15000; (i < 25000 && i<maxDiamondPrice); i = i+50) {
    price.push(i);
  };
  for (var i = 25000; (i < 50000 && i<maxDiamondPrice); i = i+100) {
    price.push(i);
  };
  for (var i = 50000; (i < 80000 && i<maxDiamondPrice); i = i+200) {
    price.push(i);
  };
  for (var i = 80000; (i < 100000 && i<maxDiamondPrice); i = i+1000) {
    price.push(i);
  };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }

                slide = '';
                return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val('');                
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }
                
                  setTimeout(function(){
                     option = true;
                   }, 25); 
                   slide = '';
                   
                   return false;                
                }
            }
             
        });
  		  
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);  		 
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_max_price);
		return false;
	} else {
		var price_min = jQuery('#price_from').val();
	}
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
	var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
	if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
		jQuery('#price_from').val(formatted_min_price);
        return false;
	} else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);		
		jQuery('#price_from').val(formatted_min_price);
		return false;
	} else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
		price_slider_render(default_price_min, price_max_value, false, filterLabel);
		return false;
	}

	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
	if ($('#price_to').val() == ''){
		var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		$('#price_to').val(formatted_min_price);        
		return false;
	} else {
		var price_max = $('#price_to').val();        
	}

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
	if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
		jQuery('#price_to').val(formatted_max_price);
        return false;
	} else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value == '') {
		jQuery('#price_from').val(price_min_value);
	}

	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace(/[^\d\.]/g, '');
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');
    price = price.replace(/\./g, '');   
  }
  return price;
}
/*** Diamond Price Filter End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
});
/*** End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter.toLowerCase(); 
     emptyProductResultDiv();
    
     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
	if (input_value == 'price') {
		$('.tps-selected-filter-container').find('li[data-input="price"]').remove();
	}else if (input_value == 'shape') {     
		$('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
	}else if (input_value == 'style') {
		$('.tps-selected-filter-container').find('li[data-input="style"]').remove();
	}else if (input_value == 'metal') {
		$('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
    }
  
	var value = filter_value.split(':');
   
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
		if ($('#' + value[0] + '-container').length > 0) {
			$('#' + value[0] + '-container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
			$('.tps-selected-filter-container').append(elecontainer);
			$('#' + value[0] + '-container').append(html);
		}    
	} else {
		$('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '-container li').length == 0) {
			$('#' + value[0] + '-container').remove();
		}
	}
	if ($('.tps-selected-filter-container li').length > 0) {
		$('.tps-selected-filter-wrapper').show();
	} else {
		$('.tps-selected-filter-wrapper').hide();
	}
}
/*** Set selected filters for session filters after reloading page end ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedSettingFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Metal' || key == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey).val(inputValues);
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }
     
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();
      
      if(filterTitle != 'shape'){
        filterValue = filterValue.replace(/\s+/g, '-');
      }
    
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Get All Setting Products Start ***/ 
function ajaxDataCall(){   
   var session_variable = jQuery("#session_variable").val();
   var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
     
   jQuery(".tps-productlist-result-grid-view-loader").show();
   jQuery("#tps_product_count").html("(<span class='tps-product-count-loader'></span>)");
   var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?limit=500'; //get ring setting products using shopify api
   var prodGridView = '';

   var session_flag = 0;
   if(session_other_data != '' && session_other_data != null){
      if(session_other_data['Product-Id'] != null && session_other_data['Product-Id'] != '' && session_other_data['Product-Id'] != undefined){
        if(session_other_data['Product-Id'][0] != undefined){
          var session_flag = 1;
        }
      }
   }

  var productsPerPage = jQuery("#products_per_page").val();
  if(session_flag != 0){
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    var pageNo = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    var showFrom = 0;
    var showTo = parseInt(productShow) - 1;
  }else{
     var pageNo = jQuery("#page_no").val();
     var productShow = pageNo * productsPerPage;
     var showFrom = productsPerPage * (pageNo - 1);
     var showTo = parseInt(showFrom) + parseInt(productsPerPage) - 1;
   }       

   abortAjax(xhr);

   xhr = $.ajax({
     type: 'GET',
     url: ringSettingUrl,
     dataType: 'json',
     success: function (data){   
       var productsData = productFilters(data); //product filter function  
       var productCount = productsData.length;
       jQuery("#tps_product_count").html("("+addCommas(productCount)+")");
       jQuery("#total_products_count").val(productCount);
       jQuery(".tps-total-products").html(addCommas(productCount));

       if(parseInt(productCount) > 0){
         $('.tps-product-grid-view-container').removeClass('tps-no-product');
         var swatchesData = new Array();

         // setTimeout(function(){
           $.each(productsData, function (i, product) {    
             if(i >= showFrom && i <= showTo){
               prodGridView += getProductGridViewLayout(product,collectionHandel);  
             }
           });
         // }, 500);

         jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);         
       }else{
          //no products found
          prodGridView += '<span class="tps-no-product-found">'+translations.titleNoProductFound+'</span>';      
          jQuery('.tps-productlist-result-grid-view-items-list').addClass('tps-no-product-found'); 
          jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);            
       }       

       if(productCount < productsPerPage || productCount == productsPerPage){         
          var previous_page_no = parseInt(pageNo)-1;
          var total_previous_products = previous_page_no*productsPerPage;
          var products_viewed = parseInt(total_previous_products)+parseInt(productCount);
        
          jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
          jQuery('.tps-total-product-found-text').hide();
          jQuery(".tps-load-more").hide();
      }else{                
          if(pageNo == 1){      
              var products_viewed = productsPerPage;
          }else{
              var products_viewed = pageNo*parseInt(productsPerPage);
              if(products_viewed > productCount){
                products_viewed = productCount;
              }
          }    
                   
          jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
          jQuery('.tps-total-product-found-text').show();

          var totalPages = productCount/productsPerPage;
          totalPages = Math.ceil(totalPages);
          if(pageNo == totalPages){
            jQuery(".tps-load-more").hide();
          }else{
            jQuery(".tps-load-more").show();
          }       
      }  

       //product info focus return from product detail page          
        if(session_flag != 0){
            var recentProduct = session_other_data['Product-Id'][0];            
            focusRecentProduct(recentProduct);            
        }             
        //end 

       jQuery(".tps-productlist-result-grid-view-loader").hide();
       var page_id = parseInt(pageNo)+1;  
       jQuery('#page_no').val(page_id);       
     }

   });
}
/*** Get All Setting Products End ***/ 

/*** Focus Recently View Product Start ***/
function focusRecentProduct(product_id) {
  var target = '.product-grid-item-'+product_id;

  if($(target).length) {
    $(target).addClass('tps-recent-viewed-product');
    $('html, body').animate({
          scrollTop: $(target).offset().top - 300
    }, 'slow'); 
  }  
  updateSessionFilters(session_variable+'-other-data','Product-Id', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-product'); }, 1500);
}
/*** End ***/

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product,collectionHandel){
  var wishlistProducts = jQuery("#wishlist_products").val();
  wishlistProducts = (typeof wishlistProducts != 'undefined' && wishlistProducts.length) ? wishlistProducts.split(",") : [];
  
  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var produtSwaches = getProductSwatches(product,collectionHandel);  
  var productVariant = getProductVariant(product,collectionHandel);
  var productPrice = Shopify.formatMoney(productVariant[0].price * 100, theme.moneyFormat);
  var productImage = productVariant[0].image;  
  
  if(productImage.includes('.png')){
    productImage = productImage.replace(".png","_300x300.png");
  }else if(productImage.includes('.jpg')){
    productImage = productImage.replace(".jpg","_300x300.jpg");
  }

  var productGrid = '';
  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-'+product.id+'" data-id="'+product.id+'" data-page="'+pageNo+'">'; 
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-media-div">';
  productGrid += '<img class="tps-productlist-item-img" data-placeholder-img="" alt="'+product.title+'" title="'+product.title+'" src="'+productImage+'" width="300" height="300">';
  productGrid += '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
  if(produtSwaches != '' && produtSwaches != null){
    productGrid += '<div class="tps-productlist-item-swatches">';
    $.each(produtSwaches, function (i, swatch) {  
      var swatchMetal = swatch.metal;
      swatchMetal = swatchMetal.replace("18ct ","");
      
      productGrid += '<div class="tps-productlist-item-swatch tps-productlist-item-swatch-'+swatch.id+' '+swatch.active+'" parent-id="'+product.id+'" data-id="'+swatch.id+'">';
      productGrid += '<div title="'+swatchMetal+'" data-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+swatch.id+'`,`'+swatch.price+'`,`'+swatch.image+'`,`'+swatch.url+'`)">';
      productGrid += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatchMetal+'</span>';
      productGrid += '</div>';
      productGrid += '</div>';
    });
    productGrid += '</div>';
  }
  
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-title">'+product.title+'</div>';  
  productGrid += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</li>';

  return productGrid;
}
/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,variantId,variantPrice,variantImage,variantUrl) {   
  jQuery('.tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);

  var productMedia = '';
  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<div class="tps-productlist-item-media-div">';
  productMedia += '<img class="tps-productlist-item-img" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" width="300" height="300">';
  productMedia += '</div>';
  productMedia += '</a>';  
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';  
  productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  productinfo += '</a>';
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');   
}
/*** On Swatches Click Change Variant Data End ***/

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product,collectionHandel){
  var variantData = new Array();
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val();
  var productVariants = product.variants;
  var productHandle = product.handle;
  var productMedia = product.images;
  var i = 0;

  if(productVariants != ''){
     variantData = getProductSelectedOption(productVariants[0],productHandle,productMedia,collectionHandel);
  }
  return variantData;  
}

function getProductSelectedOption(option,productHandle,productMedia,collectionHandel){
   var variantInfo = new Array();
   var variantShape = option.option1;
   var variantMetal = option.option2;
   var varientImage = placeholderImageUrl.ring_placeholder;
   var varientFeaturedImage  = option.featured_image;
   if(varientFeaturedImage != null){
     varientImage = option.featured_image.src;
   }
  
   
   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+option.id+'&sku='+option.sku;
  
   variantInfo.push({
      id: option.id,
      sku: option.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      image: varientImage,
      price: option.price,
   });

  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
   var swatchesData = new Array();
   var swatchesTempArr = new Array();
   var productVariants = product.variants;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();
   var variantShape = getProductShape(product.tags);
         
   if(productVariants != ''){
     $(productVariants).each(function(index, option){            
         var variantColour = option.option1;
         var variantMaterial = option.option2;
         var colourClass = variantColour.toLowerCase();
         colourClass = colourClass.replace(/\s+/g,"-");  
       
         if(shapeFilter != '' && variantShape == shapeFilter){
             var active = '';
             if(metalFilter == variantColour){
               var active = 'active'; 
             }
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             if( swatchesTempArr.includes(variantColour) == false){      
               swatchesData.push({
                  id: option.id,
                  sku: option.sku,
                  metal: variantColour,
                  shape: variantShape,
                  class: colourClass,
                  url: productUrl,
                  active: active,
                  image: option.featured_image != null ? option.featured_image.src : '',
                  price: option.price,
               });
             }
            swatchesTempArr.push(variantColour);
         }else if(shapeFilter == ''){
           var active = '';
           if(metalFilter == variantColour){
             var active = 'active'; 
           }           
           var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
           if( swatchesTempArr.includes(variantColour) == false){                 
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantColour,
                shape: variantShape,
                class: colourClass,
                url: productUrl,
                active: active,
                image: option.featured_image != null ? option.featured_image.src : '',
                price: option.price,
             });
             swatchesTempArr.push(variantColour);               
           }
         }           
     });
   }
   return swatchesData;
}
/*** Get Product Swatches Data End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & PAge No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var data_page_no = $(this).attr("data-page");
  var data_product_id = $(this).attr("data-id");
  
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
  updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
});
/*** Onclick Product Store Product ID & PAge No in Session End ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     
        
    jQuery('#page_no').val(1);
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/